import { MilestoneType, MilestoneTypes } from '@frontend/common/util';
import { Department, User } from './common-interfaces';

export interface CompletePatientFragment {
  __typename: MilestoneType;
  created_utc: string;
  created_by: string;
  department: Department;
  user?: User;
}

export const COMPLETE_PATIENT_FRAGMENT = `
  fragment ${MilestoneTypes.CompletePatientMilestone} on ${MilestoneTypes.CompletePatientMilestone} {
    __typename
    created_utc
    created_by
    department {
      name
    }
    user(with_deleted: true) {
      last_name
      first_name
      email
    }
  }
`;
